<script lang="ts">
  import { onDestroy } from 'svelte';
  import Slider from './Slider.svelte';
  export let items: any[];
  export let showScrollbar;
  export let showArrows;
  export let animate = true;
  export let autoscroll_interval = 5000;

  let slider;
  let scroll_bg;
  let scroll_progress = 0;
  let scroll_item = 0;
  $: scroll_width =(scroll_bg != null ? scroll_bg.clientWidth : 0);
  $: scroll_offset = Math.round(scroll_progress*((items.length-1)/items.length)*(scroll_width))+"px";
  $: n_items = items && items.length > 0 ? items.length : 1;

  $: items_indicator = items && items.length > 1 ? "━".repeat(items.length) : "";

  let skip_carousel = false;

  function next() {
    scroll_item = Math.min(n_items - 1, scroll_item + 1);
    slider.slide(scroll_item);
    skip_carousel = true;
  }
  function prev() {
    scroll_item = Math.max(0, Math.min(n_items - 1, scroll_item - 1));
    slider.slide(scroll_item);
    skip_carousel = true;
  }

  let autoscroll_timer = animate && setInterval(()=>{
    if (slider && !skip_carousel) {
      if (scroll_item == n_items - 1) {
        slider.slide(0);
        scroll_item = 0;
      } else {
        next();
      }
    }
    skip_carousel = false;
  }, autoscroll_interval);

  export const clearIntervals = () => {
    if (slider) {
      slider.slide(0);
    }
    scroll_item = 0;
    clearInterval(autoscroll_timer);
    
  }

  export const startAnimation = () => {
    autoscroll_timer = setInterval(()=>{
      if (slider && !skip_carousel) {
        if (scroll_item == n_items - 1) {
          slider.slide(0);
          scroll_item = 0;
        } else {
          next();
        }
      }
      skip_carousel = false;
    }, autoscroll_interval);
  }

  onDestroy(()=>{
    if (autoscroll_interval)
      clearInterval(autoscroll_timer);
  });
</script>

<carousel style="--scroll_width: {scroll_width}px">
  <div>
    {#if (items.length > 1 && showArrows)}
      <button class="left" on:click={prev}>
        <span/>
      </button>
      <button class="right" on:click={next}>
        <span/>
      </button>
    {/if}
    <Slider showScrollbar={false} bind:this={slider} bind:progress={scroll_progress}>
      {#each items as item}
        <item><slot name="item" item={item}/></item>
      {/each}
    </Slider>
  </div>
  {#if (items && items.length > 1 && showScrollbar)}
    <scroll-bg bind:this={scroll_bg} style='--bg_dots: "{items_indicator}";'>
      <scroll-indicator style='
        --scroll_offset:{scroll_offset};
        --current_indicator:"━";
      '/>
    </scroll-bg>
  {/if}
</carousel>

<style lang="scss">
  item {
    margin: auto;
    height: 100%;
    width: 100%;
    flex-shrink: 0;
    scroll-snap-align: start;
  }

  carousel {
    display: flex;
    flex-direction: column;
    position: relative;
    width:100%;

    &:hover {
      > button {
        opacity: 0.5;
      }
    }
  }
  scroll-bg {
    margin: auto;
    font-size: 24px;
    display: block;
    color:white;
    text-shadow: 0 1px 2px rgba(0,0,0,0.6);
    &:after {
      content: var(--bg_dots);
    }
    scroll-indicator {
      position: absolute;
      transform: translateX(var(--scroll_offset));
      color:lightgray;
      &:before {
        content: var(--current_indicator);
      }
    }
  }

  button {
    position: absolute;
    width: 60px;
    top: 0px;
    bottom: 34px;
    font-size: 20px;
    text-align: center;
    text-shadow: 0 1px 2px rgba(0,0,0,.6);
    background-color: rgba(0,0,0,0);
    border: unset;
    opacity: 0.0;
    transition: opacity 0.2s;

    &:hover, &:active {
      background-color: inherit;
      border: inherit;

      color: #fff;
      text-decoration: none;
      outline: 0;
      opacity: .9;
      cursor: pointer;
    }


    &.left {
      background-image: linear-gradient(to right,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001) 100%);
      left: 0%;

      span:before {
        content: "\e079";
      }
    }
    &.right {
      background-image: linear-gradient(to left,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001) 100%);
      right: 0%;

      span:before {
        content: "\e080";
      }
    }
    background-repeat: repeat-x;


    > span {
      font-family: 'Glyphicons Halflings';
      font-style: normal;
      font-weight: 400;
      font-size: 30px;
      color: white;
    }
  }
</style>